import type { SxProps, Theme } from '@mui/material/styles';
import SvgIcon from '@mui/material/SvgIcon';

type Props = {
	sx?: SxProps<Theme>;
	fill?: string;
};

export const RejectedIcon = ({ sx, fill }: Props) => {
	return (
		<SvgIcon width='17' height='17' viewBox='0 0 17 17' fill='none' sx={sx}>
			<path
				d='M7.5 10.8333H9.16667V12.5H7.5V10.8333ZM7.5 4.16667H9.16667V9.16667H7.5V4.16667ZM8.325 0C3.725 0 0 3.73333 0 8.33333C0 12.9333 3.725 16.6667 8.325 16.6667C12.9333 16.6667 16.6667 12.9333 16.6667 8.33333C16.6667 3.73333 12.9333 0 8.325 0ZM8.33333 15C4.65 15 1.66667 12.0167 1.66667 8.33333C1.66667 4.65 4.65 1.66667 8.33333 1.66667C12.0167 1.66667 15 4.65 15 8.33333C15 12.0167 12.0167 15 8.33333 15Z'
				fill={fill ?? '#E53935'}
			/>
		</SvgIcon>
	);
};
